var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.cantAccessPage === true
              ? [
                  _c("div", { staticClass: "row" }, [
                    _vm.userDetails && _vm.userDetails != ""
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "chat-btm-section-main chat-btm-user-section width-full float-l"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "top-user-detail-section col-12 float-l"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "chat-user-name-detail font-benton-bold heading-text-54 radius-100 bgcolor-71c1c5 bold relative color-white"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("filtersGetName")(
                                            _vm.userDetails.email,
                                            _vm.userDetails.name
                                          )
                                        ) +
                                        " \n                                "
                                    ),
                                    _vm._m(0)
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "username-detail center heading-text-18 line-height-22 color-333333 font-benton-bold width-full ucase pt_25"
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.userDetails.name) + " "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "site-list-section col-12 float-l relative pt_20 pb_20 border-top-e8e9ea"
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-25"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "right-site-list-section float-l width-full pl_35"
                                  },
                                  [
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"
                                      },
                                      [_vm._v(" Email ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.userDetails.email) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "site-list-section col-12 float-l relative pt_20 pb_20 border-top-e8e9ea"
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-25"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "right-site-list-section float-l width-full pl_35"
                                  },
                                  [
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"
                                      },
                                      [_vm._v(" Timezone")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.userDetails.tzName) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "site-list-section col-12 float-l relative pt_20 pb_20 border-top-e8e9ea"
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-25"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "right-site-list-section float-l width-full pl_35"
                                  },
                                  [
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"
                                      },
                                      [_vm._v(" Section ")]
                                    ),
                                    _vm._v(" "),
                                    _c("ul", [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "float-l width-full color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("filterUSting")(
                                                  _vm.userDetails.sections
                                                )
                                              ) +
                                              "  (" +
                                              _vm._s(
                                                _vm._f("filterUSting")(
                                                  _vm.userDetails.role
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              : [_vm.isRequestComplete ? [_vm._m(1)] : _vm._e()]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "edit-icon absolute" }, [
      _c("a", { attrs: { href: "#" } }, [
        _c("i", { staticClass: "hi-icon icon-chatpencil" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                                Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                                403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                                Sorry!, You don't have permission to access this page.\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23b34533", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b34533","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserDetail.vue
// module id = null
// module chunks = 